import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";

export default class ShareController extends Controller {
  initialize() {
    this.type = this.data.get("type");
    this.name = this.data.get("name");
    this.locale = this.data.get("locale");
    this.link = decodeURIComponent(window.location.href);
    I18n.locale = this.locale;
  }

  handleShare() {
    if (!this.type || !this.link || !this.name) return false;
    let shareData = this.setShareData();

    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => {
          console.log("Shared successfully!");
        })
        .catch((error) => {
          console.log("Share failed: ", error);
        });
    } else {
      this.copyToClipboard(shareData.text);
    }
  }

  setShareData() {
    const prefix = `stimulus.share.${this.type}`;
    const title = I18n.t(`${prefix}_title`, { name: this.name });
    const text = I18n.t(`${prefix}_text`, { name: this.name });

    return {
      title: title,
      text: text,
      url: this.link,
    };
  }

  copyToClipboard(text) {
    const fallbackText = `${text}\n👉 ${this.link}`;
    navigator.clipboard.writeText(fallbackText);

    Swal.fire({
      title: I18n.t("stimulus.share.copied"),
      html: `${text}<br/>👉 ${this.link}`,
      icon: "success",
      showConfirmButton: false,
      showCloseButton: true,
    });
  }
}
